import tokenStorage from "../../../player/js/tokenStorage";

export default tokenStorage;
